import { FrontendToolDefinition, FrontendToolHandler } from './types'
// Temporarily excluded from the wire payload (body.tools) — not used currently.
// Re-add the import and register() call below to re-enable.
// import { launchApp } from './tools/launchApp'
// import { openSidePanel } from './tools/openSidePanel'
// import { closeSidePanel } from './tools/closeSidePanel'
// import { applyDataFilter } from './tools/applyDataFilter'
import { shareContext } from './tools/shareContext'
import { runIntent } from './tools/runIntent'
import { linkToChannel } from './tools/linkToChannel'
import { viewFactsheet } from './tools/viewFactsheet'
import { createVisualization } from './tools/visualization/createVisualization'

const MAX_DEFINITIONS_JSON_LENGTH = 2000 // ~500 tokens ≈ ~2000 chars

class FrontendToolRegistry {
  private tools: Map<string, FrontendToolHandler> = new Map()

  register(handler: FrontendToolHandler): void {
    const { name } = handler.definition
    if (this.tools.has(name)) {
      throw new Error(`Frontend tool "${name}" is already registered.`)
    }
    this.tools.set(name, handler)
  }

  has(name: string): boolean {
    return this.tools.has(name)
  }

  get(name: string): FrontendToolHandler | undefined {
    return this.tools.get(name)
  }

  /** Wire-format-ready array for body.tools */
  getToolDefinitions(): FrontendToolDefinition[] {
    const definitions = Array.from(this.tools.values())
      .filter((h) => !h.enabled || h.enabled())
      .map((h) => h.definition)

    // Token budget guard
    const serialized = JSON.stringify(definitions)
    if (serialized.length > MAX_DEFINITIONS_JSON_LENGTH) {
      console.warn(
        `Frontend tool definitions exceed budget: ${serialized.length} chars (limit ${MAX_DEFINITIONS_JSON_LENGTH})`
      )
    }

    return definitions
  }
}

export const frontendToolRegistry = new FrontendToolRegistry()

// Register all built-in frontend tools
// Temporarily excluded to keep the tool payload lean while unused. Re-enable by
// uncommenting these registrations (and their imports above).
// frontendToolRegistry.register(launchApp)
// frontendToolRegistry.register(openSidePanel)
// frontendToolRegistry.register(closeSidePanel)
// frontendToolRegistry.register(applyDataFilter)
// Rendering tool: emits a ChartSpec the chat bubble renders via ChartRenderer.
frontendToolRegistry.register(createVisualization)
// FDC3 (Spec 010): only included in body.tools when Ali is bound to a Desktop Agent.
frontendToolRegistry.register(shareContext)
frontendToolRegistry.register(runIntent)
frontendToolRegistry.register(linkToChannel)
// Only included when a workspace app actually handles the factsheet intent.
frontendToolRegistry.register(viewFactsheet)
